export default __webpack_public_path__ + "static/media/select-case-manager.4c88c52b.png";